import { useAppContext } from 'context/AppContext'
import { CSSProperties } from 'styled-components'

export type TranslationProps = {
    className?: string
    style?: CSSProperties
    href?: string
    htmlFor?: string
    render_as?:
        | 'div'
        | 'span'
        | 'p'
        | 'label'
        | 'h2'
        | 'h3'
        | 'h4'
        | 'h5'
        | 'small'
        | 'li'
        | 'strong'
        | 'i'
        | 'a'
        | 'h1'
        | 'html'
    content_key: string
    content_values?: Record<string, string | number | Date>
    translations?: Record<string, string>
}

export function Translation(p: TranslationProps) {
    const { translations } = useAppContext()

    let text = p.translations
        ? p.translations[p.content_key]
        : translations[p.content_key]
    if (text == undefined) {
        text = p.content_key
    } else if (
        p.content_values &&
        Object.keys(p.content_values).length > 0
    ) {
        Object.keys(p.content_values).forEach((key: string) => {
            if (p.content_values && p.content_values[key] != undefined) {
                const val = p.content_values[key] as string
                text = text.split(`{${key}}`).join(val)
            }
        })
    }

    switch (p.render_as) {
        case 'div':
            return (
                <div
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </div>
            )
        case 'p':
            return (
                <p
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </p>
            )
        case 'span':
            return (
                <span
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </span>
            )
        case 'label':
            return (
                <label
                    htmlFor={p.htmlFor || ''}
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </label>
            )
        case 'h1':
            return (
                <h1
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </h1>
            )
        case 'h2':
            return (
                <h2
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </h2>
            )
        case 'h3':
            return (
                <h3
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </h3>
            )
        case 'h4':
            return (
                <h4
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </h4>
            )
        case 'h5':
            return (
                <h5
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </h5>
            )
        case 'small':
            return (
                <small
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </small>
            )
        case 'li':
            return (
                <li
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </li>
            )
        case 'strong':
            return (
                <strong
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </strong>
            )
        case 'i':
            return (
                <i
                    className={p.className || ''}
                    style={p.style || undefined}
                >
                    {text}
                </i>
            )
        case 'a':
            return (
                <a
                    className={p.className || ''}
                    href={p.href || ''}
                    style={p.style || undefined}
                >
                    {text}
                </a>
            )
        case 'html':
            return (
                <div dangerouslySetInnerHTML={{__html:text.replaceAll('\n', '<br />')}} />
            )
        default:
            return <>{text}</>
    }
}

export default Translation
